<template>
  <transition name="slide-fade">
    <CommunityCard class="m-2 media-card">
      <template v-if="isMyMedia">
        <div class="info-row" v-if="!media.is_processed">
          <em>
            This media is currently processing. Please check back later.
          </em>
        </div>
        <div
          class="info-row"
          v-else-if="media.approval_status === approvalStatus.unapproved"
        >
          <em>
            This media has not yet been approved for use. Please check back
            later.
          </em>
        </div>
        <div
          class="danger-row"
          v-else-if="media.approval_status === approvalStatus.rejected"
          @click="showRejectDetailsPopup"
        >
          <em>
            This media has been deemed unsuitable for posting. Click for details
          </em>
        </div>
      </template>

      <div
        @click="media.is_processed ? openImagePreview() : null"
        v-bind:id="id"
        class="preview-container d-flex align-items-center"
        v-bind:style="{
          backgroundImage: 'url(' + media.signed_thumb_url + ')',
        }"
      >
        <div class="media-type-overlay d-flex align-items-center">
          <div v-if="media.is_video" class>
            <i class="material-icons privacy">videocam</i>
          </div>
          <div v-else class>
            <i class="material-icons privacy">image</i>
          </div>
        </div>
      </div>

      <div class="p-4 media-content">
        <router-link
          :to="{ name: 'media-view', params: { uuidId: media.uuid_id } }"
          :disabled="!media.is_processed"
          :event="media.is_processed ? 'click' : ''"
        >
          <h5 class="mb-1">{{ media.name }}</h5>
        </router-link>
        <p>
          {{ media.is_video ? "Video" : "Image" }} ({{ humanFileSize }}),
          {{ media.num_downloads }} Downloads
        </p>
        <p
          class="description"
          v-if="
            media.description &&
            media.description !== 'undefined' &&
            media.description != null
          "
        >
          {{ media.description }}
        </p>

        <div v-if="media.tags.length" class="tags">
          <ul class="px-0 my-3 d-flex flex-wrap flex-lg-nowrap list-style-none">
            <li
              v-for="tag in media.tags"
              v-bind:key="tag.id"
              v-bind:class="{ selected: tag.isCurrentlySelected, 'my-1': true }"
            >
              {{ tag.title }}
            </li>
          </ul>
        </div>
        <div class="button-container d-flex">
          <router-link
            class="edit-button mr-2 btn btn-light w-100"
            :to="{ name: 'media-edit', params: { uuidId: media.uuid_id } }"
            :disabled="!media.is_processed"
            :event="media.is_processed ? 'click' : ''"
            tag="button"
          >
            <img alt="edit button" src="../assets/edit.svg" class="pr-1 pb-1" />
            Edit
          </router-link>

          <button
            class="btn btn-light download-button ml-2"
            @click="media.is_processed ? downloadMedia() : null"
          >
            <img
              alt="download button"
              src="../assets/download.svg"
              class="pr-1 pb-1"
            />
            Download
          </button>
        </div>
      </div>
    </CommunityCard>
  </transition>
</template>

<script>
import mediaService from "../services/media.service";
import CommunityCard from "./CommunityCard";

export default {
  name: "Media",
  components: {
    CommunityCard,
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    humanFileSize() {
      var i = Math.floor(Math.log(this.media.file_size) / Math.log(1024));
      return (
        (this.media.file_size / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "KiB", "MiB", "GiB", "TiB"][i]
      );
    },
    approvalStatus() {
      return {
        unapproved: 0,
        rejected: 1,
        approved: 2,
      };
    },
  },
  data: function () {
    return {
      id: null,
    };
  },
  props: {
    media: Object,
    isMyMedia: Boolean,
  },
  methods: {
    showImagePreview() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        title: "Title",
        text: "<img src='" + myImage.src + "'/>",
        html: true,
      });

      swalWithBootstrapButtons.fire({
        title: "Delete " + this.media.name + "?",
        html:
          "Deleting a scenario will remove it from Community, including groups. Users who have already downloaded the scenario to their device will still have access to it.<br> <br> If you still want access to your scenario in Community you can always change its visibility to private.",
        type: "warning",
        showCancelButton: true,

        confirmButtonText: "Delete",
      });
    },
    downloadMedia() {
      mediaService.downloadMedia(this.media.uuid_id).then((data) => {
        if (this.isOnNative) {
          let url = data.url;
          window.webkit.messageHandlers.mediaImport.postMessage({
            url: data.url,
            fileName: data.fileName,
          });
        } else {
          window.location = data.url;
        }
      });
    },
    showRejectDetailsPopup() {
      const sanitised = this.media.rejection_reason.replace(
        /<\s*script\s*>|<\/\s*script\s*>/gim,
        ""
      );

      this.$swal.fire("Media declined", sanitised);
    },
    changePrivacyLevel(newLevel) {
      let data = { privacy_level: newLevel };
      mediaService.editMedia(data, this.media.uuid_id).then((response) => {
        this.media.privacy_level = Number(response.newLevel);
      });
    },
    lazyLoadPreview: function () {
      function getBgUrl(el) {
        const background = el.currentStyle
          ? el.currentStyle.backgroundImage
          : document.defaultView && document.defaultView.getComputedStyle
          ? document.defaultView.getComputedStyle(el, "").backgroundImage
          : el.style.backgroundImage;

        return background.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
      }

      const previewContainer = document.getElementById(this.id);
      const image = document.createElement("img");
      image.src = getBgUrl(document.getElementById(this.id));
      image.onload = function () {
        previewContainer.className += " fade-in";
      };
    },
    openImagePreview() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          confirmButtonText: "Close",
        },
        buttonsStyling: false,
        heightAuto: true,
        html: `<div class="full-screen-preview preview-container" >
            <img style="max-height: 100%; width: 90%" 
              alt="preview" src="${this.media.signed_full_url}"/>
          </div>`,
      });
      swalWithBootstrapButtons.fire({});
    },
  },
  beforeMount() {
    this.id = "preview-pane-" + this._uid;
  },
  mounted() {
    this.lazyLoadPreview();
  },
};
</script>

<style scoped>
.info-row,
.danger-row {
  background: var(--isim-warning);
  padding: 10px;
  cursor: pointer;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: inherit;
}
.danger-row {
  background: var(--isim-danger);
  color: white;
}

.info-row a,
.info-row a:visited {
  color: inherit;
}

.media-card {
  width: 30%;
  min-width: 200px;
}

.media-content {
  font-size: 0.87rem;
  color: var(--isim-light-text);
}

.button-container {
  justify-content: space-around;
}

.edit-button,
.download-button {
  width: 45%;
}

.edit-button button,
.download-button {
  font-size: 0.8rem;
  color: var(--isim-primary);
}

.preview-container {
  position: relative;
  min-height: 260px;
  max-width: 100%;
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  opacity: 0;
  cursor: pointer;
}

.tags li {
  background: var(--isim-primary);
  color: var(--light);
  padding: 6px;
  margin-right: 8px;
  border-radius: 4px;
}

.fade-in {
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
  -moz-transition: opacity 0.25s ease-in-out;
  -webkit-transition: opacity 0.25s ease-in-out;
}

.media-type-overlay {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  opacity: 0.5;
}

.media-type-overlay i {
  color: #fff;
  font-size: 80px;
}

.noColor {
  filter: grayscale();
  opacity: 0.7;
}

@media (max-width: 620px) {
  .media-card {
    max-width: none;
  }
}
</style>
